import { Fragment } from 'react'

import { Dialog, Transition } from '@headlessui/react'
import { useWindowSize } from 'react-use'
import { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/zoom'
import { Swiper, SwiperSlide } from 'swiper/react'

import { AppImage } from '~/components/data-display/AppImage'
import { CloseIcon } from '~/components/icons'
import { TweetOrReply, tweetImageToSrc } from '~/libs/tweet'

export const TweetImageDialog: React.FC<{
  onClose: () => void
  selectedImage?: {
    tweetOrReply: TweetOrReply
    index: number
  }
}> = (props) => {
  const windowSize = useWindowSize()

  return (
    <div>
      <Transition appear show={props.selectedImage != null} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <div className="fixed inset-0">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child as={Fragment}>
                <Dialog.Panel className="h-fit-screen flex items-center bg-[#434343]">
                  <div>
                    <div className="text-right pr-4 mb-2 max-w-lg mx-auto">
                      <button
                        type="button"
                        onClick={() => props.onClose()}
                        className="outline-none"
                      >
                        <CloseIcon className="fill-white w-[14px] h-[14px]" />
                      </button>
                    </div>
                    <div>
                      <Swiper
                        zoom
                        modules={[Pagination, Navigation]}
                        pagination
                        // 画像に被って見えにくくなるの上に、元々スワイプで切り替えられるので
                        // モバイルでは Navigation を表示しない
                        navigation={windowSize.width > 768}
                        slidesPerView={1}
                        className="w-screen h-[70vh]"
                        initialSlide={props.selectedImage?.index}
                      >
                        {props.selectedImage?.tweetOrReply.value.images.map(
                          (image) => (
                            <SwiperSlide
                              zoom
                              key={image.imageId}
                              className="justify-center flex px-4"
                            >
                              <AppImage
                                width={520}
                                height={520 * 0.75}
                                alt="投稿画像"
                                src={tweetImageToSrc(image)}
                                variant={{
                                  type: 'contain',
                                }}
                                rounded="none"
                                imageClassName="max-w-full max-h-[50vh]"
                              />
                            </SwiperSlide>
                          )
                        )}
                      </Swiper>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}
